__turbopack_context__.v({
  "app_light_theme": "SlideButtons-module-scss-module__Il3VSW__app_light_theme",
  "root": "SlideButtons-module-scss-module__Il3VSW__root",
});
